import React from 'react'
import PropTypes from 'prop-types'
import ReorderIcon from '@material-ui/icons/Reorder'
import { IconButton } from '@material-ui/core'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import { SortableHandle } from 'react-sortable-hoc'
import ContextMenu from './ContextMenu'
import styles from './DraggableItemIcons.icss'

class DraggableItemIcons extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			showContextMenu: false
		}
		this.contextEl = React.createRef()
		this.handleContextClose = this.handleContextClose.bind(this)
		this.handleContextOpen = this.handleContextOpen.bind(this)
		this.bindActionAndClose = this.bindActionAndClose.bind(this)
	}

	handleContextClose() {
		this.setState({ showContextMenu: false })
	}

	handleContextOpen() {
		this.setState({ showContextMenu: true })
	}

	bindActionAndClose(action) {
		return () => {
			this.handleContextClose()
			action()
		}
	}

	render() {
		const { item, index, handleMoveUpItem, handleMoveDownItem, handleDeleteItem } = this.props

		const HandleComponent = SortableHandle(() => (
			<div className={styles.reorder}>
				<IconButton aria-label="Reorder" classes={{ label: styles.rorder }}>
					<ReorderIcon />
				</IconButton>
			</div>
		))

		return (
			<section className={styles.afterItem}>
				<HandleComponent />
				<div>
					<div className={styles.contextBtn}>
						<IconButton aria-label="Context" onClick={this.handleContextOpen}>
							<span ref={this.contextEl} />
							<MoreVertIcon />
						</IconButton>
					</div>
					{this.state.showContextMenu && (
						<ContextMenu
							contextMenuItems={[
								...(handleMoveUpItem ? [{
									name: this.context.translate('Move up'),
									handler: () => handleMoveUpItem(index, item)
								}] : []),
								...(handleMoveDownItem ? [{
									name: this.context.translate('Move down'),
									handler: () => handleMoveDownItem(index, item)
								}] : []),
								...(handleDeleteItem ? [{
									name: this.context.translate('Delete'),
									handler: () => handleDeleteItem(index, item)
								}] : [])
							]}
							handleContextClose={this.handleContextClose}
							anchorEl={this.contextEl.current}
							menuItemClickBinder={this.bindActionAndClose}
							item
						/>
					)}
				</div>
			</section>
		)
	}
}


DraggableItemIcons.contextTypes = {
	translate: PropTypes.func
}

DraggableItemIcons.propTypes = {
	item: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]), // eslint-disable-line react/forbid-prop-types
	index: PropTypes.number,
	handleMoveUpItem: PropTypes.func,
	handleMoveDownItem: PropTypes.func,
	handleDeleteItem: PropTypes.func
}

DraggableItemIcons.defaultProps = {
	item: undefined,
	index: undefined,
	handleMoveUpItem: undefined,
	handleMoveDownItem: undefined,
	handleDeleteItem: undefined
}

export default DraggableItemIcons



// WEBPACK FOOTER //
// ./src/components/DraggableItemIcons.jsx